import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientAPI } from 'src/app/features/medical-record/medical-record-page/pages/patient-informations/model/patient.model';

@Component({
  selector: 'app-patient-search-drop-down',
  templateUrl: './patient-search-drop-down.component.html',
  styleUrls: ['./patient-search-drop-down.component.scss']
})
export class PatientSearchDropDownComponent {

  @Input() patients: PatientAPI[] = [];

  @Output()
  patientSelected = new EventEmitter<PatientAPI>;

  selecPatient(patient : PatientAPI) {
    this.patientSelected.emit(patient)
  }

  genderMap(gender :PatientAPI['gender']) {
    if (gender === 'male') {
      return 'Masculino'
    } else {
      return 'Feminino'
    }
  }

}
